// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"MobileModalSectionTitle_sectionTitle__2m67d","isPassive":"MobileModalSectionTitle_isPassive__2MQuX"};